import List from "../List/List";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";
import { useParams } from 'react-router-dom';
import { EntityViewTypes } from "../../../enums/EntityViewTypes";
import RequestsLandingView from "./RequestsLandingView";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";
import GetSchema from "../entityComponents/Schema";
import { EntityNames } from "../../../enums/EntityNames";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import RecallsHubClient from "../RecallsHubClient";

export const RequestListPolling: Record<string, number | undefined> = {
    [EntityNames.operatorRecalls]: 5000,
    [EntityNames.customerRecalls]: undefined, // customer facing users do not need to see fast updates like pickers do
    [EntityNames.disposals]: undefined,
}

export default function RequestsPage(props: RouteComponentProps) {
    return (
        <RequestsPageContent />
    )
}

function RequestsPageContent({ }) {
    const { entityName } = useParams();
    const { permissions } = usePermissions();

function getPageTitle(){
    if(!entityName){
        return "Requests"
    }

    const schema = GetSchema(entityName)
    return schema.displayName
}

function canAddRequest(): boolean {
    if (!entityName) return false;
    
    // Check if user has permission to make recall or disposal requests
    if (entityName === EntityNames.operatorRecalls || entityName === EntityNames.customerRecalls) {
        return hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Make_Recall_Request);
    }
    if (entityName === EntityNames.disposals) {
        return hasPermission(permissions!, PermissionTypes.write, PermissionConcerns.Make_Disposal_Request);
    }
    
    return false;
}

    // Only connect SignalR for operator recalls - pickers need real-time updates to act on new requests immediately
    // Customer recalls don't need real-time updates as customers just submit and wait
    const shouldConnectRecallsHub = entityName === EntityNames.operatorRecalls;

    return (
        <>
            {shouldConnectRecallsHub && <RecallsHubClient />}
            <Layout entityName={entityName!} data={undefined} pageTitle={getPageTitle()} showBackButton={entityName ? true : false} showBreadcrumb={false} canScroll={false}>
                {!entityName && <RequestsLandingView />}
                {entityName && <List parentEntityName={undefined} 
                    entityId={''} 
                    entityName={entityName} 
                    enableFilters={true} 
                    searchType={EntityViewTypes.search} 
                    canAdd={canAddRequest()} 
                    tabView={false}
                    pollTime={RequestListPolling[entityName]} />}
            </Layout>
        </>
    )
}